import styled, { css } from 'styled-components';
import { FontFamilies, Media } from 'enums';

export const LogoStyled = styled.div<{ isFooter?: boolean; $season?: string }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  & > img:not(.hat-img) {
    margin-right: 14px;
    width: 32px;
    height: 32px;
    position: relative;
    z-index: 1;

    ${({ isFooter }) =>
      isFooter &&
      css`
        width: 30px;
        height: 30px;
      `}

    @media ${Media.notebook} {
      width: 40px;
      height: 40px;
    }
  }

  & > img.hat-img {
    position: absolute;
    left: -18px;
    top: -10px;
    width: 56px;
    height: 48px;
    z-index: 0;
    pointer-events: none;

    ${({ isFooter }) =>
      isFooter &&
      css`
        left: -16px;
        top: -10px;
        width: 52px;
        height: 44px;
      `}

    @media ${Media.notebook} {
      left: -26px;
      top: -14px;
      width: 70px;
      height: 60px;
    }

    ${({ $season, isFooter }) =>
      $season === 'winter' &&
      css`
        top: ${isFooter ? '-9px' : '-6px'};
        z-index: 2;

        @media ${Media.notebook} {
          top: ${isFooter ? '-14px' : '-4px'};
        }
      `}

    ${({ $season }) =>
      $season === 'fall' &&
      css`
        left: -12px;

        @media ${Media.notebook} {
          left: -20px;
        }
      `}

    ${({ $season }) =>
      $season === 'summer' &&
      css`
        left: -22px;
        top: -10px;
        width: 36px;
        height: 48px;

        @media ${Media.notebook} {
          left: -26px;
          top: -14px;
          width: 46px;
          height: 62px;
        }
      `}
  }
`;

export const LogoText = styled.p<{ isFooter?: boolean }>`
  font-family: ${FontFamilies.Roboto};
  font-weight: 500;
  font-size: 15px;
  color: ${({ isFooter, theme }) =>
    isFooter ? theme.colors.gray4 : theme.colors.gray3};

  @media ${Media.notebook} {
    font-size: 19px;
    color: ${({ isFooter, theme }) =>
      isFooter ? theme.colors.gray3 : theme.colors.gray1};
  }
`;
